import React, { memo, useContext } from 'react'
import { EditOutlined } from '@ant-design/icons'
import { Space, Tooltip, Typography } from 'antd'
import {
  TimelineInfoCard,
  TimelineInfoEditIcon,
  TimeLineContentHeaderWrapper,
  TimeLineContentWrapper,
} from '../../../styles/styles'
import { ActivityInfo } from '../../../types/types'
import TimelineItemHeader from '../activity-timeline-item-header/activity-timeline-item-header'
import { TimelineItemProps } from '../activity-timeline-Item'
import { Avatar } from '../../../../../../ui/Avatar'
import { ActivityTimelineContext } from '../../../context/activity-timeline-context'

type ActivityTimelineInfoType = Omit<TimelineItemProps, 'data'>
interface ActivityTimelineInfoProps extends ActivityTimelineInfoType {
  className?: string
  data?: ActivityInfo
}

const { Text } = Typography

const ActivityTimelineInfo: React.FC<ActivityTimelineInfoProps> = memo(
  (props: ActivityTimelineInfoProps) => {
    const { date, data, user } = props
    const { onEditHrEmployeeEvent } = useContext(ActivityTimelineContext)
    const showEdit = Boolean(data?.hrEmployeeEvent && onEditHrEmployeeEvent)
    const Card = showEdit ? TimelineInfoCard : TimeLineContentWrapper

    return (
      <>
        <Card style={showEdit ? { paddingBottom: 28 } : undefined}>
          <TimeLineContentHeaderWrapper>
            <TimelineItemHeader date={date} title={'История'} />
            <Space>
              {user && (
                <Space>
                  <Avatar src={user?.icon} alt={user?.name} />
                  <Tooltip placement="top" title="Автор">
                    <span>{user?.name}</span>
                  </Tooltip>
                </Space>
              )}
            </Space>
          </TimeLineContentHeaderWrapper>
          <Text style={{ whiteSpace: 'pre-line' }}>{data?.text}</Text>
          {showEdit && (
            <Tooltip title="Правка" placement="left">
              <TimelineInfoEditIcon
                className="timeline-info-edit"
                aria-label="Правка события"
                onClick={e => {
                  e.stopPropagation()
                  if (data && onEditHrEmployeeEvent) {
                    onEditHrEmployeeEvent(data)
                  }
                }}
              >
                <EditOutlined style={{ fontSize: 14 }} />
              </TimelineInfoEditIcon>
            </Tooltip>
          )}
        </Card>
      </>
    )
  },
)

ActivityTimelineInfo.displayName = 'ActivityTimelineInfo'
export default ActivityTimelineInfo
